/// <amd-module name="Release/Landing/Selection/SelectionStore" />

import { StoreBase } from "DistributedTask/Flux/Store";
import { ActionsHubManager } from "DistributedTask/Flux/ActionsHubManager";
import { SelectionActions, IDefinitionSelectionPayload } from "Release/Landing/Selection/SelectionActions";

export interface IDefinitionSelection extends IDefinitionSelectionPayload {
}

export class SelectionStore extends StoreBase {
    public static getKey(): string {
        return "release-landing-selection-store";
    }

    public initialize(instanceId?: string): void {
        super.initialize(instanceId);

        this._state = {
            id: -1,
            folderId: "",
            noSelection: false
        };
        this._actions = ActionsHubManager.GetActionsHub<SelectionActions>(SelectionActions);
        this._actions.selectDefinition.addListener(this._select);
        this._actions.selectInitialDefinition.addListener(this._selectInitial);
    }

    public disposeInternal(): void {
        this._actions.selectDefinition.removeListener(this._select);
    }

    public getState(): IDefinitionSelection {
        return this._state;
    }

    private _select = (payload: IDefinitionSelectionPayload): void  => { 
        if (this._state.id !== payload.id || this._state.folderId !== payload.folderId) {
            this._state = { ...this._state, ...payload };

            if (payload.id > 0) {
                this._state.noSelection = false;
            }

            if (payload.updateHistoryState === undefined) {
                this._state.updateHistoryState = true;
            }

            this.emitChanged();
        }
    }

    private _selectInitial = (payload: IDefinitionSelectionPayload): void  => { 
        this._state = { ...this._state, ...payload };

        /* Do not emit change for initialization */
    }

    private _state: IDefinitionSelection;
    private _actions: SelectionActions;
}
